import React, { useContext, useEffect, useState } from "react";
import HotelTabSidebar from "./Components/HotelTabSidebar";
import HRTabSidebar from "./Components/HRTabSidebar";
import TuningSidebar from "./Components/TuningSidebar";
import { AuthContext } from "../../Context/AuthContext";
import { getPropertyDetails } from "../../api/axios";
import UserSidebar from "./Components/UserSidebar";

const CommonSidebar = ({ iconColor }) => {
  const { user, allowedModules } = useContext(AuthContext);
  const [property, setProperty] = useState(null);
  const [activeTab, setActiveTab] = useState(null);
  const role = user?.role;
  console.log(role);

  // useEffect(() => {
  //   const loadProperty = async () => {
  //     if (!user?.property_name) return;
  //     try {
  //       const data = await getPropertyDetails(user.property_name);
  //       setProperty(data);
  //     } catch (err) {}
  //   };

  //   loadProperty();
  // }, [user?.property_name]);

  const allTabs = [
    {
      id: "tab_hotels",
      label: "Front Desk",
      module: "pms",
      component: HotelTabSidebar,
      roles: ["admin", "manager", "super-admin"],
    },
    {
      id: "tab_hrms",
      label: "HRMS",
      module: "hrms",
      component: HRTabSidebar,
      roles: ["admin", "hr-manager", "manager", "department head"],
    },
    {
      id: "tab_user_portal",
      label: "User Portal",
      module: "hrms",
      component: UserSidebar,
      roles: ["employee"],
    },
    {
      id: "tab_settings",
      label: "ADMIN",
      module: "admin",
      component: TuningSidebar,
      roles: ["admin", "super-admin"],
    },
  ];

  const visibleTabs = allTabs.filter(
    (tab) =>
      allowedModules.includes(tab.module) &&
      tab.roles.includes(role.toLowerCase())
  );

  useEffect(() => {
    if (visibleTabs.length > 0 && !activeTab) {
      setActiveTab(visibleTabs[0].id);
    }
  }, [visibleTabs, activeTab]);

  return (
    <aside
      className="ps-xl-5 ps-lg-4 ps-3 pe-2 py-3 sidebar sticky-top"
      id="sidebarDark"
      data-bs-theme="none"
    >
      <nav className="navbar navbar-expand-xl py-0">
        <div
          className="offcanvas offcanvas-start"
          data-bs-scroll="true"
          tabIndex="-1"
          id="offcanvas_Navbar"
        >
          <div className="offcanvas-header">
            <span className="fw-bold fs-5 text-gradient">
              {/* {property ? property.property_name : "Loading..."} */}
            </span>
            <button
              type="button"
              className="btn-close btn-close-white"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            ></button>
          </div>
          <div className="offcanvas-body flex-column custom_scroll ps-4 ps-xl-0">
            <div className="d-flex align-items-start mb-4">
              <div className="p-3 rounded-4 bg-white shadow-sm">
                <h3 className="title-font fw-bold text-gradient mb-1">
                  Welcome
                </h3>
                <span className="px-3 py-1 rounded-pill bg-dark text-white small fw-semibold">
                  {user?.name}
                </span>
              </div>
            </div>

            <ul
              className="nav nav-tabs tab-dynamic px-0 mb-4"
              role="tablist"
              style={{ "--dynamic-color": "var(--accent-color)" }}
            >
              {visibleTabs.map((tab, index) => (
                <li className="nav-item" role="presentation" key={tab.id}>
                  <a
                    className={`ps-2 pe-3 nav-link ${
                      index === 0 ? "active" : ""
                    }`}
                    data-bs-toggle="tab"
                    href={`#${tab.id}`}
                    role="tab"
                    aria-selected={index === 0}
                    tabIndex={index === 0 ? "0" : "-1"}
                  >
                    {tab.label}
                  </a>
                </li>
              ))}
            </ul>
            <div className="tab-content">
              {visibleTabs.map((tab, index) => {
                const TabComponent = tab.component;
                return (
                  <TabComponent
                    isActive={activeTab === tab.id}
                    iconColor={iconColor}
                  />
                );
              })}
            </div>
          </div>
        </div>
      </nav>
    </aside>
  );
};

export default CommonSidebar;

// const CommonSidebar = ({ iconColor }) => {
//   const { user, allowedModules } = useContext(AuthContext);
//   const [property, setProperty] = useState(null);
//   const [activeTab, setActiveTab] = useState(null);
//   const role = user?.role;

//   useEffect(() => {
//     const loadProperty = async () => {
//       if (!user?.property_name) return;
//       try {
//         const data = await getPropertyDetails(user.property_name);
//         setProperty(data);
//       } catch (err) {}
//     };

//     loadProperty();
//   }, [user?.property_name]);

//   const allTabs = [
//     {
//       id: "tab_hotels",
//       label: "F DESK",
//       module: "pms",
//       component: HotelTabSidebar,
//       roles: ["admin", "manager", "super-admin"],
//     },
//     {
//       id: "tab_hrms",
//       label: "HRMS",
//       module: "hrms",
//       component: HRTabSidebar,
//       roles: ["admin", "hr-manager", "manager"],
//     },
//     {
//       id: "tab_user_portal",
//       label: "User Portal",
//       module: "hrms",
//       component: UserSidebar,
//       roles: ["employee"],
//     },
//     {
//       id: "tab_settings",
//       label: "ADMIN",
//       module: "admin",
//       component: TuningSidebar,
//       roles: ["admin", "super-admin"],
//     },
//   ];

//   const visibleTabs = allTabs.filter(
//     (tab) => allowedModules.includes(tab.module) && tab.roles.includes(role)
//   );

//   useEffect(() => {
//     if (visibleTabs.length > 0 && !activeTab) {
//       setActiveTab(visibleTabs[0].id);
//     }
//   }, [visibleTabs, activeTab]);

//   return (
//     <aside className="ps-xl-5 ps-lg-4 ps-3 pe-2 py-3 sidebar sticky-top">
//       <nav className="navbar navbar-expand-xl py-0">
//         <div
//           className="offcanvas offcanvas-start"
//           data-bs-scroll="true"
//           tabIndex="-1"
//           id="offcanvas_Navbar"
//         >
//           <div className="offcanvas-header">
//             <span className="fw-bold fs-5 text-gradient">
//               {property ? property.property_name : "Loading..."}
//             </span>
//             <button
//               type="button"
//               className="btn-close btn-close-white"
//               data-bs-dismiss="offcanvas"
//             ></button>
//           </div>

//           <div className="offcanvas-body flex-column custom_scroll ps-4 ps-xl-0">
//             <div className="d-flex align-items-start mb-4">
//               <div className="p-3 rounded-4 bg-white shadow-sm">
//                 <h3 className="title-font fw-bold text-gradient mb-1">
//                   Welcome
//                 </h3>
//                 <span className="px-3 py-1 rounded-pill bg-dark text-white small fw-semibold">
//                   {user?.name}
//                 </span>
//               </div>
//             </div>

//             <ul
//               className="nav nav-tabs tab-dynamic px-0 mb-4"
//               role="tablist"
//               style={{ "--dynamic-color": "var(--accent-color)" }}
//             >
//               {visibleTabs.map((tab, index) => (
//                 <li className="nav-item" role="presentation" key={tab.id}>
//                   <a
//                     className={`ps-2 pe-3 nav-link ${
//                       index === 0 ? "active" : ""
//                     }`}
//                     data-bs-toggle="tab"
//                     href={`#${tab.id}`}
//                     role="tab"
//                     aria-selected={index === 0}
//                     tabIndex={index === 0 ? "0" : "-1"}
//                   >
//                     {tab.label}
//                   </a>
//                 </li>
//               ))}
//             </ul>

//             <div className="tab-content">
//               {visibleTabs.map((tab, index) => {
//                 const TabComponent = tab.component;
//                 return (
//                   <TabComponent
//                     isActive={activeTab === tab.id}
//                     iconColor={iconColor}
//                   />
//                 );
//               })}
//             </div>
//           </div>
//         </div>
//       </nav>
//     </aside>
//   );
// };

// export default CommonSidebar;
